export default __webpack_public_path__ + "static/media/HelveticaNeue.65877644.woff";